import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { createTheme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
})

const useStyles = makeStyles(() => ({
  gridContainer: {
    paddingTop: 80,
    justifyContent: "center",
    [theme.breakpoints.up('md')]: {
      paddingRight: 200,
      justifyContent: "flex-end",
    },
  },
  paperContainer: {
    backgroundImage: `url(${process.env.PUBLIC_URL+"background.jpg"})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center top",
    minHeight: 400,
    color: '#e7e6e1',
    [theme.breakpoints.up('md')]: {
      minHeight: 500,
    },
  }
}));

export default function Philosophy() {
  const classes = useStyles();

  return (
    <div>
      <Paper square={true} elevation={0} className={classes.paperContainer}>
        <Grid container className={classes.gridContainer}>
          <Typography variant="h3" align="right" className={classes.philosophy}>
            We <br/>
            Build Games <br/>
            We <br/>
            Create Fun
          </Typography>
        </Grid>
      </Paper>
    </div>
  );
}